export const IMAGE_PATHS = {
  PROFILE: '/assets/images/profile.png',
  PASSWORD: '/assets/images/lock.png',
  EMAIL: '/assets/images/email.png',
  CALL: '/assets/images/call.png',
  ROLE: '/assets/images/note-2.png',
  CARD: '/assets/images/personalcard.png',
  LOCATION: '/assets/images/location.png',
  CHECK: '/assets/images/tick-circle.png',
  BUILDING: '/assets/images/buildings.png',
  ZIPCODE: '/assets/images/password-check.png',
  STATE: '/assets/images/globalEdit.png',
  COUNTRY: '/assets/images/global.png',
  messageNotif: '/assets/images/messageNotif.png',
  PLAY_STORE_BADGE: '/assets/images/google-play-badge.png',
  APP_STORE_BADGE: '/assets/images/app-store-badge.png',
  CARD_POS: '/assets/images/card-pos.png',
  CALENDER: '/assets/images/calendar.png',
  COMING_SOON: '/assets/images/comingSoon.png'
};
